import { __decorate, __extends } from "tslib";
import { attachShadowTemplate, CustomElement, FoundationProperty, upgradeProperty, coerceBoolean } from '@tyler-components-web/core';
import { BackdropComponent } from '../backdrop';
import { BottomSheetAdapter } from './bottom-sheet-adapter';
import { BOTTOM_SHEET_CONSTANTS } from './bottom-sheet-constants';
import { BottomSheetFoundation } from './bottom-sheet-foundation';
var template = require('./bottom-sheet.html');
var styles = require('./bottom-sheet.css');
var BottomSheetComponent = /** @class */ (function (_super) {
    __extends(BottomSheetComponent, _super);
    function BottomSheetComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, BOTTOM_SHEET_CONSTANTS.elementName, template, styles);
        _this._foundation = new BottomSheetFoundation(new BottomSheetAdapter(_this));
        return _this;
    }
    Object.defineProperty(BottomSheetComponent, "observedAttributes", {
        get: function () {
            return [
                BOTTOM_SHEET_CONSTANTS.attributes.BACKDROP_CLOSE,
                BOTTOM_SHEET_CONSTANTS.attributes.ESCAPE_CLOSE,
                BOTTOM_SHEET_CONSTANTS.attributes.OPEN,
                BOTTOM_SHEET_CONSTANTS.attributes.FULLSCREEN,
                BOTTOM_SHEET_CONSTANTS.attributes.SHOW_BACKDROP
            ];
        },
        enumerable: true,
        configurable: true
    });
    BottomSheetComponent.prototype.initializedCallback = function () {
        upgradeProperty(this, 'backdropClose');
        upgradeProperty(this, 'escapeClose');
        upgradeProperty(this, 'open');
        upgradeProperty(this, 'fullscreen');
        upgradeProperty(this, 'showBackdrop');
    };
    BottomSheetComponent.prototype.connectedCallback = function () {
        this._foundation.initialize();
    };
    BottomSheetComponent.prototype.disconnectedCallback = function () {
        this._foundation.destroy();
    };
    BottomSheetComponent.prototype.attributeChangedCallback = function (name, _oldValue, newValue) {
        switch (name) {
            case BOTTOM_SHEET_CONSTANTS.attributes.BACKDROP_CLOSE:
                this.backdropClose = coerceBoolean(newValue);
                break;
            case BOTTOM_SHEET_CONSTANTS.attributes.ESCAPE_CLOSE:
                this.escapeClose = coerceBoolean(newValue);
                break;
            case BOTTOM_SHEET_CONSTANTS.attributes.OPEN:
                this.open = coerceBoolean(newValue);
                break;
            case BOTTOM_SHEET_CONSTANTS.attributes.FULLSCREEN:
                this.fullscreen = coerceBoolean(newValue);
                break;
            case BOTTOM_SHEET_CONSTANTS.attributes.SHOW_BACKDROP:
                this.showBackdrop = coerceBoolean(newValue);
                break;
        }
    };
    __decorate([
        FoundationProperty()
    ], BottomSheetComponent.prototype, "backdropClose", void 0);
    __decorate([
        FoundationProperty()
    ], BottomSheetComponent.prototype, "escapeClose", void 0);
    __decorate([
        FoundationProperty()
    ], BottomSheetComponent.prototype, "open", void 0);
    __decorate([
        FoundationProperty()
    ], BottomSheetComponent.prototype, "fullscreen", void 0);
    __decorate([
        FoundationProperty()
    ], BottomSheetComponent.prototype, "showBackdrop", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BottomSheetComponent.prototype, "openCallback", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BottomSheetComponent.prototype, "closeCallback", void 0);
    __decorate([
        FoundationProperty({ get: false })
    ], BottomSheetComponent.prototype, "beforeCloseCallback", void 0);
    BottomSheetComponent = __decorate([
        CustomElement({
            name: BOTTOM_SHEET_CONSTANTS.elementName,
            dependencies: [BackdropComponent]
        })
    ], BottomSheetComponent);
    return BottomSheetComponent;
}(HTMLElement));
export { BottomSheetComponent };
